import { ClassThemeProvider } from '@class-ui/theme';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LegacyRecordingsWrapper } from '../components/legacyRecordings/LegacyRecordingsWrapper';
import { LegacyRecordingsProvider } from '../context/LegacyRecordingsContext';

const LegacyRecordingsPage = () => {
    const { ready } = useTranslation('lti');

    const renderPage = () => (
        <ClassThemeProvider>
            <LegacyRecordingsProvider>
                <LegacyRecordingsWrapper />
            </LegacyRecordingsProvider>
        </ClassThemeProvider>
    );
    return ready ? renderPage() : <CircularProgress />;
};

export default LegacyRecordingsPage;
